<template>
	<header class="header">
		<div class="header-container">
			<div v-if="$route.name !== 'Product'" v-show="animate" class="logo-wrapper">
				<a @click="Helpers.ga().send('click','championat-logo')" href="https://www.championat.com/" class="champ-logo" target="_blank">
					<champlogo></champlogo>
				</a>
				<a @click="Helpers.ga().send('click','fifa-logo')" target="_blank"
				   href="https://www.easports.com/ru/fifa/buy/russia?utm_campaign=fifa18_hd_ru_scm_fixd_dcm&utm_medium=display&utm_source=championat_logo_sp&utm_content=banner&utm_term=c3" class="fifa-logo">
					<fifalogo></fifalogo>
				</a>
			</div>
			<div class="burger" v-show="animate" :class="{open: isToggle}" @click="openMobileMenu" v-if="Helpers.isMobile() || Helpers.isTouch()">
				<span></span>
				<span></span>
				<span></span>
			</div>
			<nav class="nav" v-show="animate" :class="{open: isToggle}">
				<ul class="nav-list">
					<li class="nav-item" @click="sendEvent('О проекте')">
						<router-link to="/" class="nav-link index" @click.native="openMobileMenu">О проекте</router-link>
					</li>
					<li class="nav-item" @click="sendEvent('Правила')">
						<router-link to="/rules" class="nav-link" @click.native="openMobileMenu">Правила</router-link>
					</li>
					<li class="nav-item" @click="sendEvent('Тест')">
						<router-link to="/test" class="nav-link" @click.native="openMobileMenu">Тест</router-link>
					</li>
					<li class="nav-item" @click="sendEvent('Видеоотчеты')">
						<router-link to="/video" class="nav-link" @click.native="openMobileMenu">Видеоотчеты</router-link>
					</li>
					<li class="nav-item" @click="sendEvent('FIFA 18')">
						<router-link to="/product" class="nav-link" @click.native="openMobileMenu">FIFA 18</router-link>
					</li>
					<li class="nav-item"@click="sendEvent('Рейтинг')">
						<router-link to="/rating" class="nav-link" @click.native="openMobileMenu">рейтинг</router-link>
					</li>
					<li class="nav-item nav-user-item" @click="sendEvent('Авторизация')">
						<a @click.prevent="authPopup" href="#" v-if="isGuest" class="nav-link">Войти</a>
						<div v-else class="user-link">
							<router-link to="/profile" href="#" class="nav-link user" @click.native="openMobileMenu">{{user.first_name}}</router-link>
							<a @click.prevent="logout" href="#" class="logout">X</a>
						</div>
					</li>
				</ul>
			</nav>
		</div>
	</header>
</template>

<script>
	import {TweenMax} from 'gsap'
	import Helpers from '@/tools/Helpers'

	import fifalogo from '@/assets/svg/fifa-headerlogo.svg'
	import champlogo from '@/assets/svg/championat-logo.svg'

	export default {
		name: 'Header',
		data() {
			return {
				Helpers,
				isToggle: false
			}
		},
		components: {
			Helpers,
			fifalogo,
			champlogo
		},
		computed: {
			isGuest() {
				return this.$store.getters['isGuest'];
			},
			user() {
				return this.$store.getters['getUserData'];
			},
			isProfilePage() {
				return this.$route.name === 'Profile';
			},
			animate() {
				return this.$store.getters['GET_UI_SHOW'];
			}
		},
		methods: {
			authPopup() {
				Helpers.ga().send('click','Авторизация - Войти');
				this.$store.commit('SET_POPUP', {name: 'Auth'});
			},
			logout() {
				Helpers.ga().send('click','Авторизация - Выйти');
				this.$store.dispatch('logout').then(
					() => {
						if (this.isProfilePage) this.$router.push('/');
					},
					() => {
						if (this.isProfilePage) this.$router.push('/');
					}
				);
			},
			openMobileMenu() {
				this.isToggle = !this.isToggle;
			},
			sendEvent(eventName) {
				Helpers.ga().send('click', 'header ', eventName)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Header.vue?426b7a07